import { FieldError } from "react-hook-form";

function getErrorMessage(error?: string | FieldError) {
  if (typeof error === "string") {
    return error;
  } else if (error) {
    return error.message;
  }
  return error;
}

export function Error({ error }: { error?: string | FieldError }) {
  const message = getErrorMessage(error);

  if (!message) return null;

  return (
    <div className="text-danger font-normal mt-1" role="alert">
      {message}
    </div>
  );
}
